import React from "react";
import { Link } from "react-router-dom";
import { useSelector, useDispatch, shallowEqual } from 'react-redux'
import { closeSidebar, toggleMenuDiario } from '../store/actions'



export default function SubMenuDiario(props) {

  const subMenuDiarioClass = useSelector((state) => state.menu.subMenuDiario, shallowEqual)
  const dispatch = useDispatch();

  const handleCloseSidebar = () => {
    dispatch(closeSidebar())
  }

  const handleToggleMenu = () => {
    dispatch(toggleMenuDiario(subMenuDiarioClass))
  }

  return (
    <nav className={subMenuDiarioClass} id="navigation">
      {props.sections.length && (
        <div className="menu-principal-container">
          <div className="sub-menu-container-diario">
            <h1 className="sub-menu-title">DIARIO ASMA ZERO</h1>
            <div className="sub-menu-ss2020-container">
              <ul id="menu-ss2020" className="sub-menu-slider-right">
                <li className="sub-menu-item">
                  <Link
                    onClick={handleCloseSidebar}
                    title="Herramientas"
                    to="/diario-asmazero"
                    className="nav-link"
                    aria-current="page"
                  >
                    Noticias
                  </Link>
                </li>
                <li className="sub-menu-item">
                  <Link
                    onClick={handleCloseSidebar}
                    title="Entrenamiento Médico"
                    to="/testimonios"
                    className="nav-link"
                    aria-current="page"
                  >
                    Testimonios
                  </Link>
                </li>
              </ul>
            </div>
            <div
              onClick={handleToggleMenu}
              className="swiper-button-prev diario swiper-button-white"
            >
              <h2
                onClick={handleToggleMenu}
                className="sub-menu-back-button-diario"
              >
                Volver
              </h2>
            </div>
            <div className="menu-redes">
              {" "}
              <a
                href="https://www.instagram.com/otgwesteurope/"
                target="_blank"
                rel="noreferrer"
              >
                <i className="fab fa-instagram"></i>
              </a>{" "}
              <a
                href="https://www.facebook.com/OTG.West.Europe/"
                target="_blank"
                rel="noreferrer"
              >
                <i className="fab fa-facebook-f"></i>
              </a>{" "}
              <a
                href="https://www.youtube.com/user/OTGWestEurope"
                target="_blank"
                rel="noreferrer"
              >
                <i className="fab fa-youtube"></i>
              </a>{" "}
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}
